import React, { ReactNode, useContext, useMemo } from 'react';
import {
  AvtaleApi,
  AvtaleApiInterface,
  BrukerApi,
  BrukerApiInterface,
  PraksiskalenderApi,
  PraksiskalenderApiInterface,
  PraksisstedApi,
  PraksisstedApiInterface,
  StudiestedApi,
  StudiestedApiInterface,
  VurderingApi,
  VurderingApiInterface,
  VurderingStudentApi,
  VurderingStudentApiInterface,
} from './generated/praksissted-generated-api';
import { SessionContext } from './sessionExtension';

export interface PraksisstedApiStore {
  praksisstedApi: PraksisstedApiInterface;
  studiestedApi: StudiestedApiInterface;
  brukerApi: BrukerApiInterface;
  praksiskalenderApi: PraksiskalenderApiInterface;
  vurderingApi: VurderingApiInterface;
  vurderingStudentApi: VurderingStudentApiInterface;
  avtaleApi: AvtaleApiInterface;
}

export const PraksisstedApiContext = React.createContext<PraksisstedApiStore>({
  praksisstedApi: new PraksisstedApi(() => {}),
  studiestedApi: new StudiestedApi(() => {}),
  brukerApi: new BrukerApi(() => {}),
  praksiskalenderApi: new PraksiskalenderApi(() => {}),
  vurderingApi: new VurderingApi(() => {}),
  vurderingStudentApi: new VurderingStudentApi(() => {}),
  avtaleApi: new AvtaleApi(() => {}),
});

export const PraksisstedApiProvider: React.FC<
  React.PropsWithChildren<{ children: ReactNode }>
> = ({ children }) => {
  const { setKeepAlive } = useContext(SessionContext);

  const praksisstedApiStore: PraksisstedApiStore = useMemo(
    () => ({
      praksisstedApi: new PraksisstedApi(setKeepAlive),
      studiestedApi: new StudiestedApi(setKeepAlive),
      brukerApi: new BrukerApi(setKeepAlive),
      praksiskalenderApi: new PraksiskalenderApi(setKeepAlive),
      vurderingApi: new VurderingApi(setKeepAlive),
      vurderingStudentApi: new VurderingStudentApi(setKeepAlive),
      avtaleApi: new AvtaleApi(setKeepAlive),
    }),
    [setKeepAlive],
  );

  return (
    <PraksisstedApiContext.Provider value={praksisstedApiStore}>
      {children}
    </PraksisstedApiContext.Provider>
  );
};
